// import styles from "./addReportPage.module.css";

import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Header } from "../../../components/header/header";
import { Input } from "../../../components/input/input";
import { Button } from "../../../components/button/button";
import { Separator } from "../../../components/separator/separator";
import CheckListAPI from "../../../api/CheckListAPI";
import { useAnimatedNavigate } from "../../../hooks/useAnimatedNavigate";
import { InputWithOptions } from "../../../components/inputWithOptions/InputWithOptions";

export const AddReportPage = () => {
    const cafeId = useSelector(state => state.user.userData?.cafeId);

    const [title, setTitle] = useState("");
    const [titleError, setTitleError] = useState(false);

    const [date, setDate] = useState(new Date());
    const [dateError, setDateError] = useState(false);

    const [objectName, setObjectName] = useState("");
    const [objectNameError, setObjectNameError] = useState(false);
    const [objectNameOptions, setObjectNameOptions] = useState([]);

    const [shift, setShift] = useState(new Date());
    const [shiftError, setShiftError] = useState(false);

    const [supervisor, setSupervisor] = useState("");
    const [supervisorError, setSupervisorError] = useState(false);

    const [comment, setComment] = useState("");

    useEffect(() => setTitleError(false), [title]);
    useEffect(() => setDateError(false), [date]);
    useEffect(() => setObjectNameError(false), [objectName]);
    useEffect(() => setShiftError(false), [shift]);
    useEffect(() => setSupervisorError(false), [supervisor]);

    useEffect(() => {
        if (!cafeId) return;

        CheckListAPI
            .fetchDailyReportObjectNames(cafeId)
            .then((res) => setObjectNameOptions(res || []))
            .catch(console.error);
    }, [cafeId]);

    const validate = () => {
        let error = false;

        if (title.length === 0) {
            setTitleError(true);
            error = true;
        }

        if (!date) {
            setDateError(true);
            error = true;
        }

        if (objectName.trim().length < 3) {
            setObjectNameError(true);
            error = true;
        }

        if (!shift) {
            setShiftError(true);
            error = true;
        }

        if (supervisor.length === 0) {
            setSupervisorError(true);
            error = true;
        }

        return error;
    }

    const [saving, setSaving] = useState(false);
    const navigate = useAnimatedNavigate();
    const onSave = () => {
        if (validate()) return;

        setSaving(true);
        CheckListAPI
            .createDailyReport(
                date,
                objectName.trim(),
                shift,
                supervisor,
                comment,
                title
            )
            .then(() => navigate(`/profile/reports`))
            .catch(console.error)
            .finally(() => setSaving(false));
    }

    return (
        <>
            <Header title="Сгенерировать отчет" />

            <Input
                label="Заголовок отчета"
                type="text"
                value={title}
                setValue={setTitle}
                error={titleError}
            />

            <InputWithOptions
                label="Название объекта"
                type="text"
                value={objectName}
                setValue={setObjectName}
                error={objectNameError}
                options={objectNameOptions}
            />

            <Input
                label="Проверяющий"
                type="text"
                value={supervisor}
                setValue={setSupervisor}
                error={supervisorError}
            />

            <Input
                label="Комментарий"
                type="text"
                value={comment}
                setValue={setComment}
            />

            <Input
                label="Дата отчета"
                type="date"
                value={date.toISOString().split("T")[0]}
                setValue={(val) => {
                    try {
                        const newDate = new Date(val);
                        newDate.toISOString();
                        setDate(newDate);
                    } catch {
                        setDate(prev => prev);
                    }
                }}
                error={dateError}
            />

            <Input
                label="Смена"
                type="date"
                value={shift.toISOString().split("T")[0]}
                setValue={(val) => {
                    try {
                        const newDate = new Date(val);
                        newDate.toISOString();
                        setShift(newDate);
                    } catch {
                        setShift(prev => prev);
                    }
                }}
                error={shiftError}
            />

            <Separator />

            <Button
                fixed
                disabled={saving}
                text="Сохранить"
                onClick={onSave}
            />
        </>
    );
}